/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */

import React from 'react';
import PropTypes from 'prop-types';

import {
  BREEDER_EDIT_PROFILE_PATH,
  BREEDER_SETTINGS_ACCOUNT_PATH,
  BREEDER_CENTER_PATH,
  BREEDER_DOWNLOADS_PATH
} from 'dpl/shared/constants/urls';
import Icon from 'dpl/common/components/Icon';
import SmartLink from 'dpl/components/SmartLink';
import NotificationCount from 'dpl/common/components/NotificationCount';
import UserMobileHeaderDropdownTopSection from 'dpl/components/GlobalMobileMenu/GlobalMobileMenuNavigationMenu/UserMobileHeaderDropdownTopSection';
import useDashboardRoutes from 'dpl/breeder_dashboard/hooks/useDashboardRoutes';

export function BreederMobileHeaderDropdownLoggedInContentLink({
  href,
  icon,
  isReal,
  onClick,
  title,
  notificationsCount,
  locked
}) {
  let Tag;
  if (isReal) {
    Tag = 'a';
  } else if (locked) {
    Tag = 'p';
  } else {
    Tag = SmartLink;
  }

  return (
    <li key={ href }>
      <Tag
        className="BreederMobileHeaderDropdownLoggedInContent__action flex"
        onClick={ locked ? null : onClick }
        href={ locked ? null : href }
        to={ locked ? null : href }
      >
        <span className="mr3">
          <Icon className="BreederMobileHeaderDropdownLoggedInContent__icon" name={ icon } />
        </span>
        <p>{ title }</p>
        {
          notificationsCount > 0 &&
            <NotificationCount className="ml3" count={ notificationsCount } />
        }

        { locked && (
          <Icon
            className="ml4"
            name="lock-16"
            width="16px"
            height="16px"
          />
        ) }
      </Tag>
    </li>
  );
}

BreederMobileHeaderDropdownLoggedInContentLink.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isReal: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  notificationsCount: PropTypes.number,
  locked: PropTypes.bool
};

BreederMobileHeaderDropdownLoggedInContentLink.defaultProps = {
  isReal: false,
  notificationsCount: null,
  locked: false
};

export default function BreederMobileHeaderDropdownLoggedInContent({
  onLinkClick,
  onLogoutClick,
  profilePath,
  userData
}) {
  const dashboardRoutes = useDashboardRoutes();

  const PERSONAL_LINKS = [{
    href: BREEDER_EDIT_PROFILE_PATH,
    icon: 'pencil',
    title: 'Edit profile',
    isShown: true
  }, {
    href: profilePath,
    icon: 'eye',
    title: 'View profile',
    isReal: true,
    isShown: true
  }, {
    href: BREEDER_SETTINGS_ACCOUNT_PATH,
    icon: 'gear',
    title: 'Settings',
    isShown: true
  }, {
    href: BREEDER_DOWNLOADS_PATH,
    icon: 'download',
    title: 'Downloads',
    isShown: userData.published
  }, {
    href: BREEDER_CENTER_PATH,
    icon: 'info',
    title: 'Good Breeder Center',
    isReal: true,
    isShown: true
  }].filter(link => link.isShown);

  return (
    <div className="BreederMobileHeaderDropdownLoggedInContent">
      <UserMobileHeaderDropdownTopSection userData={ userData } />
      <ul className="BreederMobileHeaderDropdownLoggedInContent__actions pb6 mb6 bb b--light-gray fw-medium purple">
        {
          dashboardRoutes.map(({
            path,
            icon,
            title,
            notificationsCount,
            locked
          }) => (
            <BreederMobileHeaderDropdownLoggedInContentLink
              key={ path }
              href={ path }
              icon={ icon }
              onClick={ onLinkClick }
              title={ title }
              notificationsCount={ notificationsCount }
              locked={ locked }
            />
          ))
        }
      </ul>
      <ul className="BreederMobileHeaderDropdownLoggedInContent__actions fw-medium">
        {
          PERSONAL_LINKS.map(({
            href,
            icon,
            title,
            isReal
          }) => (
            <BreederMobileHeaderDropdownLoggedInContentLink
              key={ href }
              href={ href }
              icon={ icon }
              isReal={ isReal }
              onClick={ onLinkClick }
              title={ title }
              locked={ false }
            />
          ))
        }
        <li className="flex">
          <a
            className="pv3 flex"
            onClick={ (e) => {
              e.preventDefault();
              onLogoutClick();
            } }
            role="button"
          >
            <span className="mr3">
              <Icon className="BreederMobileHeaderDropdownLoggedInContent__icon" name="logout" />
            </span>
            <p className="flex-auto">Log out</p>
          </a>
        </li>
      </ul>
    </div>
  );
}

BreederMobileHeaderDropdownLoggedInContent.propTypes = {
  onLinkClick: PropTypes.func.isRequired,
  onLogoutClick: PropTypes.func.isRequired,
  profilePath: PropTypes.string.isRequired,
  userData: PropTypes.shape({
    first_name: PropTypes.string,
    name: PropTypes.string,
    profile_photo_url: PropTypes.string,
    published: PropTypes.bool
  }).isRequired
};
